import { createTheme } from '@mui/material/styles';

const APP_COLORS = {
  primaryMain: '#1976d2',
  primaryLight: '#42a5f5',
  primaryDark: '#1565c0',
  bgDefault: '#ffffff',
  bgPaper: '#ffffff',
  textPrimary: 'rgba(0, 0, 0, 0.87)',
  textSecondary: 'rgba(0, 0, 0, 0.6)',
  divider: 'rgba(0, 0, 0, 0.12)',
} as const;

const theme = createTheme({
  typography: {
    fontFamily: 'var(--app-font-family)',
  },
  palette: {
    primary: {
      main: APP_COLORS.primaryMain,
      light: APP_COLORS.primaryLight,
      dark: APP_COLORS.primaryDark,
    },
    background: {
      default: APP_COLORS.bgDefault,
      paper: APP_COLORS.bgPaper,
    },
    text: {
      primary: APP_COLORS.textPrimary,
      secondary: APP_COLORS.textSecondary,
    },
    divider: APP_COLORS.divider,
  },
});

export default theme;
